<template>
    <div>
        <div class="profile-style">
            <h5 class="mb-4">Tema Website</h5>

            <draggable
                v-bind="dragOptions"
                v-model="tema"
                handle=".handle"
                @start="drag = true"
                @end="drag = false"
                >

                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <div v-for="(data) in tema" :key="data.code" class="link mb-3">
                        <div class="link-drag handle align-items-center d-flex">
                            <i class="uil uil-draggabledots"></i>
                        </div>
                        <div class="link-body">
                            <div class="link-content">
                                <div class="link-item pr-5">
                                    <div><strong>{{data.name}}</strong></div>
                                    <small class="badge badge-success badge-tema" v-if="data.web_tema_id && data.is_show === 'true'">SHOW</small>
                                    <small class="badge badge-warning badge-tema" v-if="data.web_tema_id && data.is_show === 'false'">HIDE</small>
                                </div>
                                <div class="link-switch d-flex align-items-center">
                                    <a href="#" v-b-modal.modal-Tema v-on:click.prevent="ASSIGN_FORM_TEMA(data)" class="act mb-0">
                                        <i class="uil uil-pen"></i>
                                        <span class="link-tx"> Edit</span>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                </transition-group>

            </draggable>

            <div v-for="(data) in website.tema_deactive" :key="data.code" class="link mb-3">
                <div class="link-body">
                    <div class="link-content">
                        <div class="link-item pr-5">
                            <div><strong>{{data.name}}</strong></div>
                            <small class="badge badge-secondary badge-tema" v-if="!data.web_tema_id">DEACTIVE</small>
                        </div>
                        <div class="link-switch d-flex align-items-center">
                            <a href="#" class="btn btn-info"
                                @click.prevent="_activateTema(data)"
                                v-bind:class="loading_tema ? 'btn-progress' : ''"
                                :disabled="loading_tema"
                                >
                                Activate
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal id="modal-Tema" size="lg" centered hide-footer :title="modal_title" @hidden="CLEAR_FORM_TEMA">

            <ValidationObserver ref="form">
                <div class="row">
                    <div class="col-md-12">
                        <div class="d-flex">
                            <label class="pl-0 custom-switch switch-big">
                                <input v-model="formtema.is_show" name="option" true-value="true" false-value="false" type="checkbox" class="custom-switch-input">
                                <span class="custom-switch-indicator"></span>
                            </label>
                            <label class="mt-3 ml-3">
                                <span class="custom-switch-description ml-0"><strong>Status Display Tema</strong></span>
                                <p class="desc">This function is used to hide or showing tema on website</p>
                            </label>
                        </div>
                    </div>
                    <div class="col-md-12">
                         <validation-provider rules="url" v-slot="{ errors }">
                            <div class="form-group">
                                <label>Preview Tema Link</label>
                                <input v-model="formtema.url" type="text" class="form-control" name="categories">
                                <div class="invalid-input">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                </div>

                <div class="text-right mt-4">
                    <button v-on:click="validationForm(formtema.id)" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                        Save Tema
                    </button>
                </div>

            </ValidationObserver>

        </b-modal>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import {ValidationProvider, ValidationObserver } from "vee-validate";
    import draggable from 'vuedraggable'

    export default{
        data(){
            return{
                drag: false,
                loading:false,
                loading_tema:false,
                modal_title : 'Add Tema',
            }
        },
        watch:{
            'formtema':function(val){
                if(val.id){
                    this.modal_title = 'Edit Tema'
                }else if(!val.id){
                    this.modal_title = "Add Tema"
                }
            },
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            draggable,
        },
        computed:{
            ...mapState('WebsiteControl', {
                website: state => state.website,
                formtema: state => state.formtema
            }),

            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            tema: {
                get() {
                    return this.website.tema
                },
                set(value) {
                    this.SET_POSITION_TEMA(value)
                    this.updatePositionTema(value)
                }
            }
        },
        methods:{
            ...mapMutations('WebsiteControl', ['SET_POSITION_TEMA','CLEAR_FORM_TEMA','ASSIGN_FORM_TEMA']),
            ...mapActions('WebsiteControl', ['getWebsite','activateTema','updateTema','updatePositionTema']),
            
            _activateTema:function(data){
                this.loading_tema = true
                this.activateTema(data).then(() => {
                    this.loading_tema = false
                    this.getWebsite(this.$route.params.id)
                    this.$toast.success('Successfully Activate Tema')
                }).catch((error) => {
                    console.log(error)
                    this.loading = false
                    this.$toast.warning('Sorry, Something Error')
                })
            },
            validationForm: function() {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        this.updateTema(this.formtema).then(() => {
                            this.loading = false
                            this.$bvModal.hide('modal-Tema')
                            this.getWebsite(this.$route.params.id)
                            this.$toast.success('Successfully Update Tema')
                        }).catch((error) => {
                            console.log(error)
                            this.loading = false
                            this.$toast.warning('Sorry, Something Error')
                        })
                       
                    }
                });
            },
        }
    }

</script>

<style scoped>
    .badge-tema{
        padding: 2px 5px;
        border-radius: 1px;
    }
    .img-sh img{
        width: 300px;
    }
    .link-icon img,
    .link-icon .no-img{
        width: 60px;
        height: 60px;
    }
    .btn-outline-secondary.qr{
        width: 100px;
        height: 100px;
    }
    .category-themes .btn-outline-secondary.qr:nth-child(3) img{
        width: 45px !important;
    }
    .btn-outline-secondary{
        border-color: #e4e6fc;
    }
    .btn-outline-secondary.active,
    .btn-outline-secondary:hover {
        background: #e4e6fc !important;
        border-color: #e4e6fc !important;
    }

</style>
